//https://paypal.me/n818pe

import { Button, Dropdown, Flex, MenuProps, Typography } from "antd";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebaseConfig";
import { useState } from "react";

const Registry = () => {
    const [showingNumber, setShowingNumber] = useState(false);
    const [showAddress, setShowAddress] = useState(false);
    
    const items: MenuProps['items'] = [
        {
            key: 'Venmo',
            label: (
                <a href="https://venmo.com/code?user_id=3600583785186505636" onClick={() => logEvent(analytics, 'Clicked send a gift button')}>Venmo</a>
            )
        },
        {
            key: 'PayPal',
            label: (
                <a href="https://paypal.me/n818pe" onClick={() => logEvent(analytics, 'Clicked send a gift button')}>PayPal</a>
            ),
        },
        {
            key: 'ApplePay',
            label: (
                <div onMouseEnter={() => setShowingNumber(true)} onMouseLeave={() => setShowingNumber(false)}>{showingNumber ? '(503) 545-4845' : 'Apple Pay'}</div>
            )
        },
        {
            key: 'Address',
            label: (
                <div onMouseEnter={() => setShowAddress(true)} onMouseLeave={() => setShowAddress(false)}>{showAddress ? '3239 SW 179th Terrace, Beaverton, OR 97003' : 'Mail a Check'}</div>
            )
        }
    ]
    return (
        <Flex vertical gap={25}>
            <Typography.Title>Registry</Typography.Title>
            <Typography.Text>
            Since our wedding is private and we're not having a ceremony,
            we're not asking for gifts. Instead, we welcome any donations for our honeymoon.
            </Typography.Text>

            <Typography.Text>Thank you!</Typography.Text>
            <Typography.Text>- L & R ❤️</Typography.Text>

            <Dropdown menu={{ items }}>
            <Button type="primary">Send a Gift</Button>
            </Dropdown>
        </Flex>
    );
};

export default Registry;